module.exports = __webpack_public_path__ + "static/media/backgroud.52e260d5.jpg";